module.exports = __webpack_public_path__ + "img/sad-times.d1c2edd0.svg";